interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const KeyEnter = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <path
        d="M2 10.5H11C12.6569 10.5 14 9.15686 14 7.5C14 5.84315 12.6569 4.5 11 4.5H8M2 10.5L4.66667 13.1667M2 10.5L4.66667 7.83334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Barcode = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      {...props}
    >
      <path
        d="M0.132812 0.666676H1.46615V11.3333H0.132812V0.666676ZM2.79948 0.666676H4.13281V11.3333H2.79948V0.666676ZM4.79948 0.666676H6.79948V11.3333H4.79948V0.666676ZM7.46615 0.666676H8.79948V11.3333H7.46615V0.666676ZM9.46615 0.666676H10.7995V11.3333H9.46615V0.666676ZM11.4661 0.666676H13.4661V11.3333H11.4661V0.666676Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Rs = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M7.62872 12.6687L4.9756 8.67582M1.6001 12.6687V4H4.73918C5.58897 4 6.25882 4.21015 6.74872 4.63045C7.23863 5.05075 7.48424 5.62866 7.48424 6.36418C7.48424 7.0997 7.23863 7.67761 6.74872 8.09791C6.25882 8.51821 5.58897 8.72836 4.73918 8.72836H1.61323M9.35479 11.2107C9.47694 11.7361 9.77903 12.1341 10.2611 12.406C10.751 12.6687 11.3381 12.8 12.021 12.8C12.5372 12.8 12.9838 12.7304 13.3607 12.5899C13.7377 12.4493 14.0266 12.2484 14.2276 11.9857C14.4378 11.7138 14.5428 11.3986 14.5428 11.04C14.5428 10.646 14.4154 10.3216 14.1619 10.0681C13.9163 9.81457 13.496 9.53087 12.8616 9.47701L11.3249 9.34567C10.7089 9.29313 10.2873 9.01337 10.0246 8.74149C9.77115 8.46173 9.64375 8.13337 9.64375 7.75642C9.64375 7.41493 9.74882 7.11284 9.95897 6.85015C10.1691 6.57827 10.4581 6.36418 10.8258 6.20657C11.1936 6.04896 11.6099 5.97015 12.0736 5.97015C12.7474 5.97015 13.2911 6.10149 13.7022 6.36418C14.1133 6.62687 14.3813 7.04322 14.5034 7.61194"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const LoadingSpinner = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      strokeWidth={1.5}
      className="size-5 animate-spin duration-5000"
      {...props}
    >
      <path
        d="M9.99984 1.66675V5.00008M9.99984 15.0001V18.3334M4.99984 10.0001H1.6665M18.3332 10.0001H14.9998M15.8985 15.8988L13.5415 13.5417M15.8985 4.1667L13.5415 6.52372M4.10115 15.8988L6.45817 13.5417M4.10115 4.1667L6.45817 6.52372"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const CardLastFour = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="192"
      height="128"
      viewBox="0 0 192 128"
      fill="none"
      {...props}
    >
      <rect width="192" height="128" rx="6.32201" className="fill-gray-100" />
      <path
        d="M18.2013 97.7873L20.1232 100.983H20.1914L22.1218 97.7873H23.9244L21.2354 102.151L23.967 106.515H22.1346L20.1914 103.34H20.1232L18.18 106.515H16.3562L19.1133 102.151L16.3903 97.7873H18.2013ZM26.4865 97.7873L28.4084 100.983H28.4766L30.407 97.7873H32.2095L29.5206 102.151L32.2521 106.515H30.4197L28.4766 103.34H28.4084L26.4652 106.515H24.6413L27.3984 102.151L24.6754 97.7873H26.4865ZM34.7717 97.7873L36.6935 100.983H36.7617L38.6921 97.7873H40.4947L37.8058 102.151L40.5373 106.515H38.7049L36.7617 103.34H36.6935L34.7504 106.515H32.9265L35.6836 102.151L32.9606 97.7873H34.7717ZM43.0568 97.7873L44.9787 100.983H45.0469L46.9773 97.7873H48.7798L46.0909 102.151L48.8224 106.515H46.9901L45.0469 103.34H44.9787L43.0355 106.515H41.2116L43.9688 102.151L41.2457 97.7873H43.0568ZM55.549 97.7873L57.4709 100.983H57.5391L59.4695 97.7873H61.272L58.5831 102.151L61.3146 106.515H59.4822L57.5391 103.34H57.4709L55.5277 106.515H53.7038L56.4609 102.151L53.7379 97.7873H55.549ZM63.8342 97.7873L65.756 100.983H65.8242L67.7546 97.7873H69.5572L66.8683 102.151L69.5998 106.515H67.7674L65.8242 103.34H65.756L63.8129 106.515H61.989L64.7461 102.151L62.0231 97.7873H63.8342Z"
        className="fill-gray-300"
      />
      <path
        d="M53.2053 101.516L53.2053 102.786H49.2763L49.2763 101.516H53.2053ZM72.1193 97.7873L74.0412 100.983H74.1094L76.0398 97.7873H77.8423L75.1534 102.151L77.8849 106.515H76.0526L74.1094 103.34H74.0412L72.098 106.515H70.2741L73.0313 102.151L70.3082 97.7873H72.1193ZM80.4045 97.7873L82.3263 100.983H82.3945L84.3249 97.7873H86.1275L83.4386 102.151L86.1701 106.515H84.3377L82.3945 103.34H82.3263L80.3832 106.515H78.5593L81.3164 102.151L78.5934 97.7873H80.4045ZM90.5529 101.516L90.5529 102.786H86.6239L86.6239 101.516H90.5529ZM92.8967 97.7873L94.8185 100.983H94.8867L96.8171 97.7873H98.6197L95.9308 102.151L98.6623 106.515H96.8299L94.8867 103.34H94.8185L92.8754 106.515H91.0515L93.8086 102.151L91.0856 97.7873H92.8967ZM101.182 97.7873L103.104 100.983H103.172L105.102 97.7873H106.905L104.216 102.151L106.947 106.515H105.115L103.172 103.34H103.104L101.161 106.515H99.3366L102.094 102.151L99.3707 97.7873H101.182ZM109.467 97.7873L111.389 100.983H111.457L113.387 97.7873H115.19L112.501 102.151L115.233 106.515H113.4L111.457 103.34H111.389L109.446 106.515H107.622L110.379 102.151L107.656 97.7873H109.467ZM117.752 97.7873L119.674 100.983H119.742L121.673 97.7873H123.475L120.786 102.151L123.518 106.515H121.685L119.742 103.34H119.674L117.731 106.515H115.907L118.664 102.151L115.941 97.7873H117.752ZM127.901 101.516L127.901 102.786H123.972L123.972 101.516H127.901Z"
        className="fill-gray-300"
      />
      <path
        d="M130.244 97.7873L132.166 100.983H132.234L134.165 97.7873H135.967L133.278 102.151L136.01 106.515H134.178L132.234 103.34H132.166L130.223 106.515H128.399L131.156 102.151L128.433 97.7873H130.244ZM138.529 97.7873L140.451 100.983H140.52L142.45 97.7873H144.252L141.564 102.151L144.295 106.515L142.463 106.515L140.52 103.34H140.451L138.508 106.515H136.684L139.441 102.151L136.718 97.7873H138.529ZM146.815 97.7873L148.737 100.983H148.805L150.735 97.7873H152.538L149.849 102.151L152.58 106.515H150.748L148.805 103.34H148.737L146.793 106.515H144.969L147.727 102.151L145.004 97.7873H146.815ZM155.1 97.7873L157.022 100.983H157.09L159.02 97.7873H160.823L158.134 102.151L160.865 106.515H159.033L157.09 103.34H157.022L155.078 106.515H153.255L156.012 102.151L153.289 97.7873H155.1Z"
        className="fill-gray-950"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.6579 83.7841C40.896 83.7841 43.5455 81.5909 43.5455 78.9107L43.5455 68.3672C43.5455 65.9019 41.3038 63.8491 38.4246 63.5356L21.0494 63.5356C18.1828 63.8491 16.0195 65.9019 16.0195 68.3672L16.0195 78.9107C16.0195 81.5911 18.5764 83.7841 21.8146 83.7841H37.6579Z"
        fill="white"
      />
    </svg>
  )
}

export function TablerFileTypeXls(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
        <path d="M5 12V5a2 2 0 0 1 2-2h7l5 5v4M4 15l4 6m-4 0l4-6m9 5.25c0 .414.336.75.75.75H19a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1.25a.75.75 0 0 1 .75.75M11 15v6h3" />
      </g>
    </svg>
  )
}
